(function ($) {



    $(document).on('frmFormComplete', function (event, form, response) {

        if (!form) return;
        // console.log('$formEl', event, form, response)
        const $formEl = $('.frm_forms');

        $('.formidable-form-remove-el-after-submission').remove();

        const targetPosition = $formEl.offset().top - window.innerHeight * 0.3;
        // console.log('$formEl', $formEl, targetPosition)

        $('html, body').stop().animate(
            {
                scrollTop: targetPosition,
            },
            500
        )

        // your code here
    });


})(jQuery);